import React from "react";

const WORDS = [
  "Airport Transfers",
  "Corporate Travel",
  "Weddings",
  "Sightseeing",
  "Executive Sedans",
  "Special Events",
  "24/7 Dispatch",
];

export const Marquee = () => (
  <section className="border-y border-white/10 bg-background py-10 md:py-14">
    <div className="relative flex overflow-hidden">
      <div className="flex shrink-0 animate-marquee items-center whitespace-nowrap">
        {[...WORDS, ...WORDS].map((w, i) => (
          <span key={i} className="flex items-center">
            <span className="px-8 font-serif text-4xl font-light italic text-white md:text-6xl">{w}</span>
            <span className="h-2 w-2 rounded-full bg-primary" />
          </span>
        ))}
      </div>
    </div>
  </section>
);
